import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import * as routes from "../../routes";
import { renderEditor } from "../groupmessage/editor";
import { rpc } from "trader.ts/network";
import { renderSaveButton } from "../../client/savebutton";
import * as style from "../../../styles/style.css.classes";

export function render(opts: {
  currentMessage: null | { html: string; text: string };
}): HTMLElement | HTMLElement[] {
  const htmlS = new Source(opts.currentMessage?.html || "");
  const textS = new Source(opts.currentMessage?.text || "");

  async function doSave() {
    return rpc(routes.saveStudentProfilesMessageSpec, undefined, {
      html: htmlS.get(),
      text: textS.get(),
    });
  }

  const editor = renderEditor(htmlS, textS, null);

  return (
    <div className={style.card + style.card_large}>
      <label>{"Bericht"}</label>
      {editor.buttonSection}
      {editor.editablediv}
      <div style="text-align: right">
        {renderSaveButton({
          save: doSave,
          text: {
            normal: "Sla op",
            success: "Bericht opgeslagen!",
          },
          reload: false,
        })}
      </div>
    </div>
  );
}
